import styled from 'styled-components';

const GeneralInfoLine = styled.div`
  line-height: 25px;
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumRegular}
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-all; 
`;

export default GeneralInfoLine;
